import React, { useState, useEffect } from "react";
import { Field, useFormikContext } from "formik";
import { useQuery } from "@tanstack/react-query";

import { DiscountsAPI } from "../../../api/discounts";
import { FormAutocomplete } from "../index";
import { IUserEmailWithId } from "../../../api/discounts/index.types";

interface IProps {
  setFieldValue: (field: string, value: string | number | null) => void;
  setSelectedAccountId: (accounts_id: number | null) => void;
  defaultValue?: {
    email: string;
    id: number | null;
  };
}
const FormEmailAutocomplete: React.FC<IProps> = ({
  setFieldValue,
  setSelectedAccountId,
  defaultValue,
}) => {
  const [linkUserList, setLinkUserList] = useState<IUserEmailWithId[]>([]);
  const [linkUserQueryEmail, setLinkUserQueryEmail] = useState<string>(defaultValue?.email || "");
  const { submitCount } = useFormikContext();

  const emailsList = useQuery({
    queryKey: [linkUserQueryEmail],
    queryFn: async ({ signal }) => {
      try {
        if (linkUserQueryEmail.length < 3) return [];
        const response = await DiscountsAPI.getEmailsListRequest(
          { email: linkUserQueryEmail },
          signal
        );
        setLinkUserList(response.data);
        return response;
      } catch (error) {
        console.log(error);
      }
    },
  });

  const handleLinkUserSearch = (target: string) => setLinkUserQueryEmail(target);

  useEffect(() => {
    if (submitCount > 0) {
      setLinkUserList([]);
      setLinkUserQueryEmail("");
    }
  }, [submitCount]);

  return (
    <Field
      name="email"
      label="Email"
      component={FormAutocomplete}
      options={linkUserList}
      extractLabel={(option: IUserEmailWithId) => option.email || ""}
      loading={emailsList.isFetching}
      onChange={async (_: unknown, newValue: IUserEmailWithId) => {
        setSelectedAccountId(newValue?.id || null);
        setFieldValue("accounts_id", newValue?.id || null);
        window.requestAnimationFrame(() => setFieldValue("email", newValue?.email || ""));
      }}
      onChangeTextField={(e: React.ChangeEvent<HTMLInputElement>) => {
        handleLinkUserSearch(e.target.value);
        setFieldValue("email", "");
      }}
      getOptionSelected={(option: IUserEmailWithId, value: IUserEmailWithId) =>
        option.email === value.email
      }
      defaultValue={defaultValue}
    />
  );
};

export default FormEmailAutocomplete;
